import {FormikSelect} from '@flexinet/ui-components';
import {Price} from '../types';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { fetchRecords as fetchProducts } from '../../products/services/ProductsService';
import { fetchRecords as fetchPrices } from '../services/PricesService';

export const PricesDropdown = (props: FieldProps & SelectProps) => {
    // Fetch all products first
    const productsQuery = useQuery({
        queryKey: ['products'],
        queryFn: () => fetchProducts({})
    });

    // Fetch prices for all products
    const pricesQuery = useQuery({
        queryKey: ['all-prices'],
        queryFn: async () => {
            const products = productsQuery.data?.items || [];
            const allPrices: Price[] = [];
            
            for (const product of products) {
                const pricesResponse = await fetchPrices(product.id, {});
                if (pricesResponse?.items) {
                    allPrices.push(...pricesResponse.items);
                }
            }
            return allPrices;
        },
        enabled: !!productsQuery.data?.items?.length
    });

    const selectOptions = (pricesQuery.data || []).map((price: Price) => {
        return {
            value: price.id,
            label: `${price.product?.name || price.productId} - $${(price.amount / 100).toFixed(2)}`,
        };
    });

    return <FormikSelect {...props} data={selectOptions}/>;
};
